module.exports = __webpack_public_path__ + "img/Steve.d3427a19.jpeg";